import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'

import {reservation as text} from '../text'
import {reservation as styles} from '../styles'
import LoadingButton from '../../../common/components/LoadingButton'
import Calendar from './calendar'


class Reservation extends React.Component {

  render() {
    const {classes, isLoading} = this.props
    return (
      <div>
        <Title classes={classes} text={text.whenWillYouUseit}/>
        <Calendar onClick={this.props.setRange}/>
        <Actions
          classes={classes}
          onClick={this.props.saveAddItem}
          isLoading={isLoading}
          isDisabled={false}
        />
      </div>
    )
  }

  static propTypes = {
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    setRange: PropTypes.func.isRequired,
    saveAddItem: PropTypes.func.isRequired,
  }

  static defaultProps = {
    isLoading: false,
    error: '',
  }
}

const Title = ({classes, text}) => (
  <div>
    <Typography variant="title" className={classes.dialogTitle}>{text}</Typography>
  </div>
)

const Actions = ({classes, onClick, isDisabled, isLoading}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="raised"
      color="primary"
      onClick={onClick}
      disabled={isDisabled}
      isLoading={isLoading}
    >
      {text.continue}
    </LoadingButton>
  </div>
)

export default withStyles(styles, {withTheme: true})(Reservation)



// WEBPACK FOOTER //
// ./src/sections/rent/components/reservation.js